import cx from 'classnames';
import { forwardRef, ReactNode } from 'react';

interface FormGroupProps {
  children: ReactNode;
  className?: string;
}

const FormGroup = forwardRef<HTMLDivElement, FormGroupProps>(({ children, className }, ref) => {
  return (
    <div ref={ref} className={cx('flos-grid', { [className ?? '']: !!className })}>
      <div className="flos-grid--span-8">{children}</div>
    </div>
  );
});

export default FormGroup;
